// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/esign/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        readinessCheck: build.query<ReadinessCheckApiResponse, ReadinessCheckApiArg>({
            query: () => ({ url: `/health/readiness` }),
        }),
        livenessCheck: build.query<LivenessCheckApiResponse, LivenessCheckApiArg>({
            query: () => ({ url: `/health/liveness` }),
        }),
        authorize: build.mutation<AuthorizeApiResponse, AuthorizeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/authorize`,
                method: "POST",
                body: queryArg.authorizeRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        docusignCallback: build.query<DocusignCallbackApiResponse, DocusignCallbackApiArg>({
            query: () => ({ url: `/api/v1/authorize/callback/docusign` }),
        }),
        adobesignCallback: build.query<AdobesignCallbackApiResponse, AdobesignCallbackApiArg>({
            query: () => ({ url: `/api/v1/authorize/callback/adobesign` }),
        }),
        getIntegrations: build.query<GetIntegrationsApiResponse, GetIntegrationsApiArg>({
            query: () => ({ url: `/api/v1/integrations` }),
        }),
        createIntegration: build.mutation<CreateIntegrationApiResponse, CreateIntegrationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrations`,
                method: "POST",
                body: queryArg.createIntegrationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getIntegrationUsers: build.query<GetIntegrationUsersApiResponse, GetIntegrationUsersApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrations/${queryArg.integrationId}/users`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteIntegrationUserTokens: build.mutation<DeleteIntegrationUserTokensApiResponse, DeleteIntegrationUserTokensApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrations/${queryArg.integrationId}/users`,
                method: "DELETE",
                body: queryArg.deleteIntegrationTokensRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateIntegrationType: build.mutation<UpdateIntegrationTypeApiResponse, UpdateIntegrationTypeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrations/${queryArg.integrationId}`,
                method: "PATCH",
                body: queryArg.updateIntegrationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteIntegration: build.mutation<DeleteIntegrationApiResponse, DeleteIntegrationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrations/${queryArg.integrationId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getIntegrationsInternal: build.query<GetIntegrationsInternalApiResponse, GetIntegrationsInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/integrations`,
                params: { pilot_client_id: queryArg.pilotClientId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTokenStatus: build.query<GetTokenStatusApiResponse, GetTokenStatusApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tokens/status`,
                params: { ticket_id: queryArg.ticketId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createPackage: build.mutation<CreatePackageApiResponse, CreatePackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages`,
                method: "POST",
                body: queryArg.createPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackage: build.query<GetPackageApiResponse, GetPackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages`,
                params: { ticket_id: queryArg.ticketId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        voidPackage: build.mutation<VoidPackageApiResponse, VoidPackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages`,
                method: "DELETE",
                body: queryArg.voidPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageStatus: build.query<GetPackageStatusApiResponse, GetPackageStatusApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/status`,
                params: { ticket_id: queryArg.ticketId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageRecipients: build.query<GetPackageRecipientsApiResponse, GetPackageRecipientsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/recipients`,
                params: { ticket_id: queryArg.ticketId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageActivities: build.query<GetPackageActivitiesApiResponse, GetPackageActivitiesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/activities`,
                params: { ticket_id: queryArg.ticketId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageDocument: build.query<GetPackageDocumentApiResponse, GetPackageDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/document`,
                params: {
                    ticket_id: queryArg.ticketId,
                    include_cert: queryArg.includeCert,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageDocumentByTicketAndDocumentId: build.query<GetPackageDocumentByTicketAndDocumentIdApiResponse, GetPackageDocumentByTicketAndDocumentIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageCertificate: build.query<GetPackageCertificateApiResponse, GetPackageCertificateApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/certificate`,
                params: { ticket_id: queryArg.ticketId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        viewPackage: build.mutation<ViewPackageApiResponse, ViewPackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/view`,
                method: "POST",
                body: queryArg.viewPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        signPackage: build.mutation<SignPackageApiResponse, SignPackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/sign`,
                method: "POST",
                body: queryArg.signPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        remindSigner: build.mutation<RemindSignerApiResponse, RemindSignerApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/packages/remind`,
                method: "POST",
                body: queryArg.sendReminderRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createPackageInternal: build.mutation<CreatePackageInternalApiResponse, CreatePackageInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages`,
                method: "POST",
                body: queryArg.internalCreatePackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        voidPackageInternal: build.mutation<VoidPackageInternalApiResponse, VoidPackageInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages`,
                method: "DELETE",
                body: queryArg.internalVoidPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createMultiDocPackageAsync: build.mutation<CreateMultiDocPackageAsyncApiResponse, CreateMultiDocPackageAsyncApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/multi-doc/async`,
                method: "POST",
                body: queryArg.asyncCreateMultiTicketPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createMultiDocPackage: build.mutation<CreateMultiDocPackageApiResponse, CreateMultiDocPackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/multi-doc`,
                method: "POST",
                body: queryArg.internalCreateMultiTicketPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        ensureTicketsEligible: build.mutation<EnsureTicketsEligibleApiResponse, EnsureTicketsEligibleApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/eligible`,
                method: "POST",
                body: queryArg.internalEnsureTicketsEligibleRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageStatusInternal: build.query<GetPackageStatusInternalApiResponse, GetPackageStatusInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/status`,
                params: {
                    ticket_id: queryArg.ticketId,
                    pilot_user_id: queryArg.pilotUserId,
                    pilot_client_id: queryArg.pilotClientId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageRecipientsInternal: build.query<GetPackageRecipientsInternalApiResponse, GetPackageRecipientsInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/recipients`,
                params: {
                    ticket_id: queryArg.ticketId,
                    pilot_user_id: queryArg.pilotUserId,
                    pilot_client_id: queryArg.pilotClientId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageActivitiesInternal: build.query<GetPackageActivitiesInternalApiResponse, GetPackageActivitiesInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/activities`,
                params: {
                    ticket_id: queryArg.ticketId,
                    pilot_user_id: queryArg.pilotUserId,
                    pilot_client_id: queryArg.pilotClientId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageDocumentInternal: build.query<GetPackageDocumentInternalApiResponse, GetPackageDocumentInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/document`,
                params: {
                    ticket_id: queryArg.ticketId,
                    pilot_user_id: queryArg.pilotUserId,
                    pilot_client_id: queryArg.pilotClientId,
                    include_cert: queryArg.includeCert,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageDocumentByTicketAndDocumentIdInternal: build.query<GetPackageDocumentByTicketAndDocumentIdInternalApiResponse, GetPackageDocumentByTicketAndDocumentIdInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}`,
                params: {
                    pilot_user_id: queryArg.pilotUserId,
                    pilot_client_id: queryArg.pilotClientId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPackageCertificateInternal: build.query<GetPackageCertificateInternalApiResponse, GetPackageCertificateInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/certificate`,
                params: {
                    ticket_id: queryArg.ticketId,
                    pilot_user_id: queryArg.pilotUserId,
                    pilot_client_id: queryArg.pilotClientId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        signPackageInternal: build.mutation<SignPackageInternalApiResponse, SignPackageInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/sign`,
                method: "POST",
                body: queryArg.internalSignPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        viewPackageInternal: build.mutation<ViewPackageInternalApiResponse, ViewPackageInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/view`,
                method: "POST",
                body: queryArg.internalViewPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        remindSignerInternal: build.mutation<RemindSignerInternalApiResponse, RemindSignerInternalApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/packages/remind`,
                method: "POST",
                body: queryArg.internalSendReminderRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        docusignWebhook: build.mutation<DocusignWebhookApiResponse, DocusignWebhookApiArg>({
            query: () => ({ url: `/api/v1/webhook/docusign`, method: "POST" }),
        }),
        adobesignWebhookValidation: build.query<AdobesignWebhookValidationApiResponse, AdobesignWebhookValidationApiArg>({
            query: () => ({ url: `/api/v1/webhook/adobesign` }),
        }),
        adobesignWebhook: build.mutation<AdobesignWebhookApiResponse, AdobesignWebhookApiArg>({
            query: () => ({ url: `/api/v1/webhook/adobesign`, method: "POST" }),
        }),
        getVendors: build.query<GetVendorsApiResponse, GetVendorsApiArg>({
            query: () => ({ url: `/api/v1/vendors` }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ReadinessCheckApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type ReadinessCheckApiArg = void;
export type LivenessCheckApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type LivenessCheckApiArg = void;
export type AuthorizeApiResponse = 
/** status 200 Successful Response */ LinksResponse;
export type AuthorizeApiArg = {
    authorizeRequest: AuthorizeRequest;
};
export type DocusignCallbackApiResponse = unknown;
export type DocusignCallbackApiArg = void;
export type AdobesignCallbackApiResponse = unknown;
export type AdobesignCallbackApiArg = void;
export type GetIntegrationsApiResponse = 
/** status 200 Successful Response */ GetIntegrationsResponse;
export type GetIntegrationsApiArg = void;
export type CreateIntegrationApiResponse = 
/** status 201 Successful Response */ any;
export type CreateIntegrationApiArg = {
    createIntegrationRequest: CreateIntegrationRequest;
};
export type GetIntegrationUsersApiResponse = 
/** status 200 Successful Response */ GetIntegrationUsersResponse;
export type GetIntegrationUsersApiArg = {
    integrationId: string;
};
export type DeleteIntegrationUserTokensApiResponse = 
/** status 200 Successful Response */ DeleteIntegrationTokensResponse;
export type DeleteIntegrationUserTokensApiArg = {
    integrationId: string;
    deleteIntegrationTokensRequest: DeleteIntegrationTokensRequest;
};
export type UpdateIntegrationTypeApiResponse = 
/** status 204 Successful Response */ void;
export type UpdateIntegrationTypeApiArg = {
    integrationId: string;
    updateIntegrationRequest: UpdateIntegrationRequest;
};
export type DeleteIntegrationApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteIntegrationApiArg = {
    integrationId: string;
};
export type GetIntegrationsInternalApiResponse = 
/** status 200 Successful Response */ GetIntegrationsResponse;
export type GetIntegrationsInternalApiArg = {
    /** Pilot client id */
    pilotClientId: number;
};
export type GetTokenStatusApiResponse = 
/** status 200 Successful Response */ GetTokenStatusResponse;
export type GetTokenStatusApiArg = {
    /** Package ticket id */
    ticketId?: string | null;
};
export type CreatePackageApiResponse = 
/** status 201 Successful Response */ LinksResponse;
export type CreatePackageApiArg = {
    createPackageRequest: CreatePackageRequest;
};
export type GetPackageApiResponse = 
/** status 200 Successful Response */ GetPackageResponse;
export type GetPackageApiArg = {
    /** Package ticket id */
    ticketId: string;
};
export type VoidPackageApiResponse = void;
export type VoidPackageApiArg = {
    voidPackageRequest: VoidPackageRequest;
};
export type GetPackageStatusApiResponse = 
/** status 200 Successful Response */ GetPackageStatusResponse;
export type GetPackageStatusApiArg = {
    /** Package ticket id */
    ticketId: string;
};
export type GetPackageRecipientsApiResponse = 
/** status 200 Successful Response */ GetPackageRecipientsResponse;
export type GetPackageRecipientsApiArg = {
    /** Package ticket id */
    ticketId: string;
};
export type GetPackageActivitiesApiResponse = 
/** status 200 Successful Response */ GetPackageActivitiesResponse;
export type GetPackageActivitiesApiArg = {
    /** Package ticket id */
    ticketId: string;
};
export type GetPackageDocumentApiResponse = 
/** status 200 Successful Response */ any;
export type GetPackageDocumentApiArg = {
    /** Package ticket id */
    ticketId: string;
    /** Include certificate of completion with document. Feature-gated; returns 403 when disabled for the client. */
    includeCert?: boolean;
};
export type GetPackageDocumentByTicketAndDocumentIdApiResponse = 
/** status 200 Successful Response */ any;
export type GetPackageDocumentByTicketAndDocumentIdApiArg = {
    ticketId: string;
    documentId: string;
};
export type GetPackageCertificateApiResponse = 
/** status 200 Successful Response */ any;
export type GetPackageCertificateApiArg = {
    /** Package ticket id */
    ticketId: string;
};
export type ViewPackageApiResponse = 
/** status 200 Successful Response */ LinksResponse;
export type ViewPackageApiArg = {
    viewPackageRequest: ViewPackageRequest;
};
export type SignPackageApiResponse = 
/** status 200 Successful Response */ LinksResponse;
export type SignPackageApiArg = {
    signPackageRequest: SignPackageRequest;
};
export type RemindSignerApiResponse = 
/** status 204 Successful Response */ void;
export type RemindSignerApiArg = {
    sendReminderRequest: SendReminderRequest;
};
export type CreatePackageInternalApiResponse = 
/** status 201 Successful Response */ LinksResponse;
export type CreatePackageInternalApiArg = {
    internalCreatePackageRequest: InternalCreatePackageRequest;
};
export type VoidPackageInternalApiResponse = 
/** status 204 Successful Response */ void;
export type VoidPackageInternalApiArg = {
    internalVoidPackageRequest: InternalVoidPackageRequest;
};
export type CreateMultiDocPackageAsyncApiResponse = 
/** status 201 Successful Response */ AsyncPackageCreatedResponse;
export type CreateMultiDocPackageAsyncApiArg = {
    asyncCreateMultiTicketPackageRequest: AsyncCreateMultiTicketPackageRequest;
};
export type CreateMultiDocPackageApiResponse = 
/** status 201 Successful Response */ LinksResponse;
export type CreateMultiDocPackageApiArg = {
    internalCreateMultiTicketPackageRequest: InternalCreateMultiTicketPackageRequest;
};
export type EnsureTicketsEligibleApiResponse = 
/** status 200 Successful Response */ any;
export type EnsureTicketsEligibleApiArg = {
    internalEnsureTicketsEligibleRequest: InternalEnsureTicketsEligibleRequest;
};
export type GetPackageStatusInternalApiResponse = 
/** status 200 Successful Response */ GetPackageStatusResponse;
export type GetPackageStatusInternalApiArg = {
    /** Package ticket id */
    ticketId: string;
    /** Pilot user id */
    pilotUserId: number;
    /** Pilot client id */
    pilotClientId: number;
};
export type GetPackageRecipientsInternalApiResponse = 
/** status 200 Successful Response */ GetPackageRecipientsResponse;
export type GetPackageRecipientsInternalApiArg = {
    /** Package ticket id */
    ticketId: string;
    /** Pilot user id */
    pilotUserId: number;
    /** Pilot client id */
    pilotClientId: number;
};
export type GetPackageActivitiesInternalApiResponse = 
/** status 200 Successful Response */ GetPackageActivitiesResponse;
export type GetPackageActivitiesInternalApiArg = {
    /** Package ticket id */
    ticketId: string;
    /** Pilot user id */
    pilotUserId: number;
    /** Pilot client id */
    pilotClientId: number;
};
export type GetPackageDocumentInternalApiResponse = 
/** status 200 Successful Response */ any;
export type GetPackageDocumentInternalApiArg = {
    /** Package ticket id */
    ticketId: string;
    /** Pilot user id */
    pilotUserId: number;
    /** Pilot client id */
    pilotClientId: number;
    /** Include certificate of completion with document. Feature-gated; returns 403 when disabled for the client. */
    includeCert?: boolean;
};
export type GetPackageDocumentByTicketAndDocumentIdInternalApiResponse = 
/** status 200 Successful Response */ any;
export type GetPackageDocumentByTicketAndDocumentIdInternalApiArg = {
    ticketId: string;
    documentId: string;
    /** Pilot user id */
    pilotUserId: number;
    /** Pilot client id */
    pilotClientId: number;
};
export type GetPackageCertificateInternalApiResponse = 
/** status 200 Successful Response */ any;
export type GetPackageCertificateInternalApiArg = {
    /** Package ticket id */
    ticketId: string;
    /** Pilot user id */
    pilotUserId: number;
    /** Pilot client id */
    pilotClientId: number;
};
export type SignPackageInternalApiResponse = 
/** status 200 Successful Response */ LinksResponse;
export type SignPackageInternalApiArg = {
    internalSignPackageRequest: InternalSignPackageRequest;
};
export type ViewPackageInternalApiResponse = 
/** status 200 Successful Response */ LinksResponse;
export type ViewPackageInternalApiArg = {
    internalViewPackageRequest: InternalViewPackageRequest;
};
export type RemindSignerInternalApiResponse = 
/** status 204 Successful Response */ void;
export type RemindSignerInternalApiArg = {
    internalSendReminderRequest: InternalSendReminderRequest;
};
export type DocusignWebhookApiResponse = 
/** status 200 Successful Response */ any;
export type DocusignWebhookApiArg = void;
export type AdobesignWebhookValidationApiResponse = 
/** status 200 Successful Response */ any;
export type AdobesignWebhookValidationApiArg = void;
export type AdobesignWebhookApiResponse = 
/** status 200 Successful Response */ any;
export type AdobesignWebhookApiArg = void;
export type GetVendorsApiResponse = 
/** status 200 Successful Response */ GetVendorsResponse;
export type GetVendorsApiArg = void;
export type CheckResult = {
    name: string;
    passed: boolean;
    details?: string | null;
};
export type HealthcheckReport = {
    healthy: boolean;
    checks: CheckResult[];
};
export type LinksResponse = {
    type: string;
    id: string;
    links: {
        [key: string]: string;
    };
};
export type ErrorData = {
    status: number;
    code: string;
    title: string;
    detail: string;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ErrorResponse = {
    errors: ErrorData[];
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    type: string;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type AuthorizeRequestAttributes = {
    return_url: string;
};
export type AuthorizeRequestData = {
    type?: string;
    attributes: AuthorizeRequestAttributes;
};
export type AuthorizeRequest = {
    data: AuthorizeRequestData;
};
export type IntegrationType = "PERSONAL" | "COMPANY";
export type Vendor = "DOCUSIGN" | "ADOBESIGN";
export type IntegrationDetailed = {
    type?: IntegrationType;
    vendor: Vendor;
    /** Total number of token, active or dead */
    authenticated_user_count: number;
    /** Whether the user has any active tokens */
    has_active_token: boolean;
};
export type GetIntegrationsResponseData = {
    type?: string;
    id: string;
    attributes: IntegrationDetailed;
};
export type GetIntegrationsResponse = {
    data: GetIntegrationsResponseData[];
};
export type CreateIntegrationRequestAttributes = {
    type?: IntegrationType;
    vendor: Vendor;
};
export type CreateIntegrationRequestData = {
    type?: string;
    attributes: CreateIntegrationRequestAttributes;
};
export type CreateIntegrationRequest = {
    data: CreateIntegrationRequestData;
};
export type IntegrationUser = {
    internal_user_id: number;
    external_user_email: string;
};
export type GetIntegrationUserResponseData = {
    type?: string;
    id: string;
    attributes: IntegrationUser;
};
export type GetIntegrationUsersResponse = {
    data: GetIntegrationUserResponseData[];
};
export type DeleteIntegrationTokensResponseAttributes = {
    deleted_tokens: string[];
};
export type DeleteIntegrationTokensResponseData = {
    type?: string;
    id: string;
    attributes: DeleteIntegrationTokensResponseAttributes;
};
export type DeleteIntegrationTokensResponse = {
    data: DeleteIntegrationTokensResponseData;
};
export type DeleteIntegrationTokensRequestAttributes = {
    token_ids: string[];
};
export type DeleteIntegrationTokensRequestData = {
    type?: string;
    attributes: DeleteIntegrationTokensRequestAttributes;
};
export type DeleteIntegrationTokensRequest = {
    data: DeleteIntegrationTokensRequestData;
};
export type UpdateIntegrationRequestAttributes = {
    type: IntegrationType;
};
export type UpdateIntegrationRequestData = {
    type?: string;
    attributes: UpdateIntegrationRequestAttributes;
};
export type UpdateIntegrationRequest = {
    data: UpdateIntegrationRequestData;
};
export type TokenStatus = "UNINITIALIZED" | "ACTIVE" | "DEAD";
export type GetTokenStatusResponseAttributes = {
    account_token: TokenStatus;
    envelope_token?: TokenStatus | null;
    user_token: TokenStatus;
    integration_type: IntegrationType;
    vendor: Vendor;
};
export type GetTokenStatusResponseData = {
    type?: string;
    id: string;
    attributes: GetTokenStatusResponseAttributes;
};
export type GetTokenStatusResponse = {
    data: GetTokenStatusResponseData;
};
export type User = {
    name: string;
    email: string;
    pilot_user_id: number;
};
export type InitialDocument = {
    filename?: string;
    file_extension?: string;
    base64_content?: string | null;
    /** HTTPS URL to fetch document bytes (e.g. presigned S3 GET). Mutually exclusive with base64_content. */
    document_url?: string | null;
    /** Evisort document ID (UUID as string). Required for multi-doc packages. */
    document_id?: string | null;
};
export type BaseAnchorTag = {
    string: string;
    x_offset?: string | null;
    y_offset?: string | null;
};
export type AnchorTag = {
    string: string;
    x_offset?: string | null;
    y_offset?: string | null;
    width?: string | null;
    locked?: string;
    value?: string | null;
};
export type PartyAnchor = {
    company_name?: AnchorTag | null;
    company_address?: AnchorTag | null;
    contact_name?: AnchorTag | null;
    contact_email?: AnchorTag | null;
    contact_phone?: AnchorTag | null;
    wildcard_text?: AnchorTag | null;
};
export type SignerAnchor = {
    signature?: BaseAnchorTag | null;
    date_signed?: BaseAnchorTag | null;
    initials?: BaseAnchorTag | null;
    name?: AnchorTag | null;
    email?: AnchorTag | null;
    title?: AnchorTag | null;
    address?: AnchorTag | null;
    wildcard_text?: AnchorTag | null;
    party_anchors?: PartyAnchor | null;
    extra_text_tabs?: {
        [key: string]: AnchorTag;
    };
};
export type InitialSigner = {
    name: string;
    email: string;
    order: number;
    pilot_user_id?: number | null;
    /** anchor string and associated values */
    anchor_tag_values: SignerAnchor;
};
export type CreatePackageRequestAttributes = {
    ticket_name: string;
    sender: User;
    coordinator: User;
    document: InitialDocument;
    signers: InitialSigner[];
    return_url: string;
    ticket_id: string;
    vendor: Vendor;
};
export type CreatePackageRequestData = {
    type?: string;
    attributes: CreatePackageRequestAttributes;
};
export type CreatePackageRequest = {
    data: CreatePackageRequestData;
};
export type Signer = {
    name: string;
    email: string;
    status?: string;
    order: number;
    recipient_id?: string | null;
    signed_date_time?: string | null;
    /** the indication of DocuSign using captive signing feature */
    client_user_id?: string | null;
    is_external?: boolean | null;
};
export type Cc = {
    name: string;
    email: string;
};
export type PackageRecipients = {
    signers?: Signer[];
    carbon_copies?: Cc[];
};
export type PackageActivity = {
    timestamp: string;
    message: string;
    username: string;
    activity_type?: string | null;
};
export type EnvelopeMetadata = {
    ticket_id: string;
    client_id: string;
    envelope_id: string;
};
export type GetPackageResponseAttributes = {
    status: string;
    recipients?: PackageRecipients;
    activities?: PackageActivity[];
    metadata: EnvelopeMetadata;
};
export type GetPackageResponseData = {
    type?: string;
    id: string;
    attributes: GetPackageResponseAttributes;
};
export type GetPackageResponse = {
    data: GetPackageResponseData;
};
export type VoidPackageRequestAttributes = {
    ticket_id: string;
    void_reason?: string | null;
};
export type VoidPackageRequestData = {
    type?: string;
    attributes: VoidPackageRequestAttributes;
};
export type VoidPackageRequest = {
    data: VoidPackageRequestData;
};
export type GetPackageStatusResponseAttributes = {
    status: string;
};
export type GetPackageStatusResponseData = {
    type?: string;
    id: string;
    attributes: GetPackageStatusResponseAttributes;
};
export type GetPackageStatusResponse = {
    data: GetPackageStatusResponseData;
};
export type GetPackageRecipientsResponseAttributes = {
    recipients?: PackageRecipients;
};
export type GetPackageRecipientsResponseData = {
    type?: string;
    id: string;
    attributes: GetPackageRecipientsResponseAttributes;
};
export type GetPackageRecipientsResponse = {
    data: GetPackageRecipientsResponseData;
};
export type GetPackageActivitiesResponseAttributes = {
    activities?: PackageActivity[];
};
export type GetPackageActivitiesResponseData = {
    type?: string;
    id: string;
    attributes: GetPackageActivitiesResponseAttributes;
};
export type GetPackageActivitiesResponse = {
    data: GetPackageActivitiesResponseData;
};
export type PackageViewMode = "auto" | "sender" | "console" | "correct";
export type ViewPackageRequestAttributes = {
    ticket_id: string;
    return_url: string;
    view_mode?: PackageViewMode;
};
export type ViewPackageRequestData = {
    type?: string;
    attributes: ViewPackageRequestAttributes;
};
export type ViewPackageRequest = {
    data: ViewPackageRequestData;
};
export type SignPackageRequestAttributes = {
    ticket_id: string;
    return_url: string;
    recipient_id: string;
};
export type SignPackageRequestData = {
    type?: string;
    attributes: SignPackageRequestAttributes;
};
export type SignPackageRequest = {
    data: SignPackageRequestData;
};
export type SendReminderRequestAttributes = {
    ticket_id: string;
    recipient_id: string;
    reminder_note?: string | null;
};
export type SendReminderRequestData = {
    type?: string;
    attributes: SendReminderRequestAttributes;
};
export type SendReminderRequest = {
    data: SendReminderRequestData;
};
export type InternalCreatePackageRequestAttributes = {
    pilot_user_id: number;
    pilot_client_id: number;
    ticket_name: string;
    sender: User;
    coordinator: User;
    document: InitialDocument;
    signers: InitialSigner[];
    return_url: string;
    ticket_id: string;
    vendor: Vendor;
};
export type InternalCreatePackageRequestData = {
    type?: string;
    attributes: InternalCreatePackageRequestAttributes;
};
export type InternalCreatePackageRequest = {
    data: InternalCreatePackageRequestData;
};
export type InternalVoidPackageRequestAttributes = {
    pilot_user_id: number;
    pilot_client_id: number;
    ticket_id: string;
    void_reason?: string | null;
};
export type InternalVoidPackageRequestData = {
    type?: string;
    attributes: InternalVoidPackageRequestAttributes;
};
export type InternalVoidPackageRequest = {
    data: InternalVoidPackageRequestData;
};
export type AsyncPackageCreatedResponse = {
    type: string;
    id: string;
};
export type AsyncCreateMultiTicketPackageRequestAttributes = {
    package_name: string;
    sender: User;
    coordinator: User;
    documents: InitialDocument[];
    signers: InitialSigner[];
    ticket_ids: string[];
    return_url?: string;
    pilot_user_id: number;
    pilot_client_id: number;
};
export type AsyncCreateMultiTicketPackageRequestData = {
    type?: string;
    attributes: AsyncCreateMultiTicketPackageRequestAttributes;
};
export type AsyncCreateMultiTicketPackageRequest = {
    data: AsyncCreateMultiTicketPackageRequestData;
};
export type InternalCreateMultiTicketPackageRequestAttributes = {
    package_name: string;
    sender: User;
    coordinator: User;
    documents: InitialDocument[];
    signers: InitialSigner[];
    ticket_ids: string[];
    return_url: string;
    pilot_user_id: number;
    pilot_client_id: number;
    vendor: Vendor;
};
export type InternalCreateMultiTicketPackageRequestData = {
    type?: string;
    attributes: InternalCreateMultiTicketPackageRequestAttributes;
};
export type InternalCreateMultiTicketPackageRequest = {
    data: InternalCreateMultiTicketPackageRequestData;
};
export type InternalEnsureTicketsEligibleRequestAttributes = {
    pilot_user_id: number;
    pilot_client_id: number;
    /** Ticket IDs to check for eligibility */
    ticket_ids: string[];
};
export type InternalEnsureTicketsEligibleRequestData = {
    type?: string;
    attributes: InternalEnsureTicketsEligibleRequestAttributes;
};
export type InternalEnsureTicketsEligibleRequest = {
    data: InternalEnsureTicketsEligibleRequestData;
};
export type InternalSignPackageRequestAttributes = {
    pilot_user_id: number;
    pilot_client_id: number;
    ticket_id: string;
    return_url: string;
    recipient_id: string;
};
export type InternalSignPackageRequestData = {
    type?: string;
    attributes: InternalSignPackageRequestAttributes;
};
export type InternalSignPackageRequest = {
    data: InternalSignPackageRequestData;
};
export type InternalViewPackageRequestAttributes = {
    pilot_user_id: number;
    pilot_client_id: number;
    ticket_id: string;
    return_url: string;
    view_mode?: PackageViewMode;
};
export type InternalViewPackageRequestData = {
    type?: string;
    attributes: InternalViewPackageRequestAttributes;
};
export type InternalViewPackageRequest = {
    data: InternalViewPackageRequestData;
};
export type InternalSendReminderRequestAttributes = {
    pilot_user_id: number;
    pilot_client_id: number;
    ticket_id: string;
    recipient_id: string;
    reminder_note?: string | null;
};
export type InternalSendReminderRequestData = {
    type?: string;
    attributes: InternalSendReminderRequestAttributes;
};
export type InternalSendReminderRequest = {
    data: InternalSendReminderRequestData;
};
export type VendorResponse = {
    name: string;
};
export type GetVendorsResponseData = {
    type?: string;
    id: string;
    attributes: VendorResponse;
};
export type GetVendorsResponse = {
    data: GetVendorsResponseData[];
};
